<aside class="js-drawer-settings p-0">
  <div class="offcanvas-header app-drawer-header">
    <div class="h4 mb-0">Sources</div>
    <button type="button" class="btn btn-system ms-auto" (click)="close()">
      <svg class="sa-icon sa-icon-2x">
        <use href="/assets/icons/sprite.svg#x"></use>
      </svg>
    </button>
  </div>

  <ngx-simplebar class="offcanvas-body h-100" style="max-height: 100%">
    @if (canCreate) {
      <div class="toolbar-actions d-flex mb-3">
        <button
          type="button"
          class="btn btn-primary action-btn new-btn"
          data-testid="source-add"
          (click)="onAdd()"
        >
          +Adicionar
        </button>
      </div>
    }

    @if (errorMessage()) {
      <div class="alert alert-danger py-2 mb-3">{{ errorMessage() }}</div>
    }

    @if (!canRead) {
      <div class="small text-muted" data-testid="source-read-denied">
        Voce nao possui permissao para visualizar fontes.
      </div>
    } @else if (isLoading()) {
      <div class="small text-muted">Carregando fontes...</div>
    } @else if (visibleFiles().length) {
      <div class="source-file-list">
        @for (file of visibleFiles(); track file.id) {
          <div class="source-file-item">
            <div
              class="source-file-name text-truncate"
              [title]="file.originalFileName"
            >
              {{ file.originalFileName }}
            </div>
            @if (canDelete) {
              <button
                type="button"
                class="btn btn-system source-trash-btn"
                data-testid="source-delete"
                [disabled]="isDeleting()"
                [attr.aria-label]="'Excluir arquivo ' + file.originalFileName"
                (click)="confirmDelete(file)"
              >
                <svg class="sa-icon sa-bold sa-nofill">
                  <use href="/assets/icons/sprite.svg#trash-2"></use>
                </svg>
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <div class="small text-muted">Nenhuma fonte importada.</div>
    }
  </ngx-simplebar>
</aside>
